import React from "react"
import { TrendingUp, TrendingDown, Star, AlertTriangle } from "lucide-react"
import { Card, CardContent } from "../ui/card"
import { cn } from "../../lib/utils"

export default function StatCard({ 
  title, 
  value, 
  subtitle, 
  trend = "neutral",
  icon = null,
  className 
}) {
  const getTrendIcon = () => {
    switch (trend) {
      case "up":
        return <TrendingUp className="h-4 w-4 text-green-500" />
      case "down":
        return <TrendingDown className="h-4 w-4 text-red-500" />
      case "attention":
        return <AlertTriangle className="h-4 w-4 text-yellow-500" />
      default:
        return null
    }
  }

  const getIcon = () => {
    if (icon === "star") {
      return <Star className="h-4 w-4 text-yellow-500 fill-yellow-500" />
    }
    return getTrendIcon()
  }

  return (
    <Card className={cn("", className)}>
      <CardContent className="pt-6">
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold tracking-tight">{value}</p>
            {subtitle && (
              <p className="text-xs text-muted-foreground">{subtitle}</p>
            )}
          </div>
          {getIcon()}
        </div>
      </CardContent>
    </Card>
  )
}
